const faqFunctions = () => {
    const setExpandedState = ($question, $answer, isExpanded) => {
        const $answerInner = $answer.find('.faq__answer-inner');

        $question.attr('aria-expanded', isExpanded ? 'true' : 'false');

        if ( isExpanded ) {
            $answer.prop('hidden', false);
            $answer.css('max-height', $answerInner.outerHeight(true) + 'px');
        } else {
            $answer.css('max-height', $answerInner.outerHeight(true) + 'px');

            window.requestAnimationFrame(function() {
                $answer.css('max-height', 0);
            });

            $answer.one('transitionend', function() {
                if ( $question.attr('aria-expanded') === 'false' ) {
                    $answer.prop('hidden', true);
                }
            });
        }
    };

    $(document).on('click', '.js-faq-question', function(e) {
        e.preventDefault();

        const $question = $(this);
        const $answer = $('#' + $question.attr('aria-controls'));
        const isExpanded = $question.attr('aria-expanded') === 'true';

        if ( !isExpanded ) {
            $question.closest('.faq').find('.js-faq-question[aria-expanded="true"]').each(function() {
                const $other = $(this);
                if ( $other.is($question) ) {
                    return;
                }
                setExpandedState($other, $('#' + $other.attr('aria-controls')), false);
            });
        }

        setExpandedState($question, $answer, !isExpanded);
    });

    $(window).on('resize', function() {
        $('.js-faq-question[aria-expanded="true"]').each(function() {
            const $question = $(this);
            const $answer = $('#' + $question.attr('aria-controls'));

            if ( $answer.length ) {
                $answer.css('max-height', $answer.find('.faq__answer-inner').outerHeight(true) + 'px');
            }
        });
    });
};
